var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12C18.4926 12 19.5 13.0074 19.5 14.25V15C19.5 17.9572 16.7107 21 12 21C7.28926 21 4.5 17.9572 4.5 15V14.25C4.5 13.0074 5.50736 12 6.75 12H17.25ZM17.25 13.5H6.75C6.33579 13.5 6 13.8358 6 14.25V15C6 17.1565 8.14824 19.5 12 19.5C15.8518 19.5 18 17.1565 18 15V14.25C18 13.8358 17.6642 13.5 17.25 13.5ZM12 2.25C14.2782 2.25 16.125 4.09683 16.125 6.375C16.125 8.65317 14.2782 10.5 12 10.5C9.72183 10.5 7.875 8.65317 7.875 6.375C7.875 4.09683 9.72183 2.25 12 2.25ZM12 3.75C10.5503 3.75 9.375 4.92525 9.375 6.375C9.375 7.82475 10.5503 9 12 9C13.4497 9 14.625 7.82475 14.625 6.375C14.625 4.92525 13.4497 3.75 12 3.75Z",
    fill: "#404767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.59900edd733c821aea7d9325e5da921e.svg";
export { ForwardRef as ReactComponent };